import { useKeycloak } from '@react-keycloak/web';
import { useMemo } from 'react';
import type { User } from '../types';
import { authService } from '../services/auth';

export const useAuth = () => {
  const { keycloak, initialized } = useKeycloak();

  const user: User | null = useMemo(() => {
    return authService.getCurrentUser();
  }, [keycloak.authenticated, keycloak.tokenParsed]);

  const isAuthenticated = keycloak.authenticated || false;

  const logout = async () => {
    await authService.logout();
  };

  const hasRole = (role: string): boolean => {
    return authService.hasRole(role);
  };

  return {
    user,
    isAuthenticated,
    isLoading: !initialized,
    logout,
    hasRole,
    keycloak,
  };
};
